import { CsvEnrichmentType } from "@/enum/csv-enrichment.enum";

export interface MappingFieldOption {
	title: string;
	id: string;
	compares?: string[];
}

/**
 * The acceptable minimum field-combinations per entity type — at least one combination
 * must be fully mapped before an upload is allowed.
 */
export const getMinimumFields = (entityType?: string | null): string[][] => {
	if (entityType === CsvEnrichmentType.ORGANIZATION) {
		return [["companyName"], ["companyLinkedinUrl"], ["companyDomain"]];
	} else if (entityType === CsvEnrichmentType.PERSON) {
		return [
			["linkedinUrl"],
			["firstName", "lastName", "companyName"],
			["firstName", "lastName", "companyLinkedinUrl"],
			["firstName", "lastName", "companyDomain"],
			["name", "companyName"],
			["name", "companyLinkedinUrl"],
			["name", "companyDomain"],
		];
	} else if (entityType === CsvEnrichmentType.PERSON_BY_TITLE) {
		return [
			["title", "companyName"],
			["title", "companyLinkedinUrl"],
			["title", "companyDomain"],
		];
	}

	return [];
};

/**
 * The assignable mapping targets per entity type. `compares` holds the column-header
 * spellings used for the immediate fallback match before the AI suggestion lands.
 */
export const getDefaultOptions = (entityType?: string | null): MappingFieldOption[] => {
	if (entityType === CsvEnrichmentType.ORGANIZATION) {
		return [
			{ title: "Do Not import", id: "" },
			{ title: "Company Name", id: "companyName", compares: ["companyName", "Company Name"] },
			{
				title: "Company Website",
				id: "companyDomain",
				compares: ["companyDomain", "Company Website"],
			},
			{
				title: "Company Linkedin",
				id: "companyLinkedinUrl",
				compares: ["companyLinkedinUrl", "Company Linkedin"],
			},
			{
				title: "Company Country",
				id: "companyCountry",
				compares: ["companyCountry", "Company Country"],
			},
			{ title: "Save as Custom Field", id: "customField" },
		];
	} else if (entityType === CsvEnrichmentType.PERSON) {
		return [
			{ title: "Do Not import", id: "" },
			{ title: "Email Address", id: "email", compares: ["email", "Email Address", "Email"] },
			{ title: "Job Title", id: "title", compares: ["title", "Job Title", "Position"] },
			{ title: "Full Name", id: "name", compares: ["name", "Name"] },
			{ title: "Firstname", id: "firstName", compares: ["firstName", "Firstname", "First Name"] },
			{ title: "Lastname", id: "lastName", compares: ["lastName", "Lastname", "Last Name"] },
			{ title: "Company Name", id: "companyName", compares: ["companyName", "Company Name"] },
			{
				title: "Company Website",
				id: "companyDomain",
				compares: ["companyDomain", "Company Website"],
			},
			{
				title: "Personal Linkedin",
				id: "linkedinUrl",
				compares: ["linkedinUrl", "Personal Linkedin", "LinkedIn URL"],
			},
			{
				title: "Company Linkedin",
				id: "companyLinkedinUrl",
				compares: ["companyLinkedinUrl", "Company Linkedin"],
			},
			{
				title: "Company Country",
				id: "companyCountry",
				compares: ["companyCountry", "Company Country"],
			},
			{ title: "Save as Custom Field", id: "customField" },
		];
	} else if (entityType === CsvEnrichmentType.PERSON_BY_TITLE) {
		return [
			{ title: "Do Not import", id: "" },
			{ title: "Job Title", id: "title", compares: ["title", "Job Title"] },
			{ title: "Company Name", id: "companyName", compares: ["companyName", "Company Name"] },
			{
				title: "Company Website",
				id: "companyDomain",
				compares: ["companyDomain", "Company Website"],
			},
			{
				title: "Company Linkedin",
				id: "companyLinkedinUrl",
				compares: ["companyLinkedinUrl", "Company Linkedin"],
			},
			{
				title: "Company Country",
				id: "companyCountry",
				compares: ["companyCountry", "Company Country"],
			},
			{
				title: "Personal Country",
				id: "personalCountry",
				compares: ["personalCountry", "Personal Country"],
			},
			{ title: "Save as Custom Field", id: "customField" },
		];
	}

	return [];
};
